import SafeHtml from './SafeHtml.ts.vue';
export default [
    SafeHtml,
];
